import React from 'react';

const RatingProgressBar = ({ star, reviews }) => {
    // Ensure reviews is an array before proceeding
    const safeReviews = Array.isArray(reviews) ? reviews : [];

    // Calculate the percentage for each star level
    const calculateStarPercentage = (star) => {
        const totalReviews = safeReviews.length;

        // Filter reviews based on the rounded star rating
        const countForStar = safeReviews.filter(
            (review) => Math.round(review.rating) === star
        ).length;

        return totalReviews > 0 ? (countForStar / totalReviews) * 100 : 0;
    };

    const percentage = calculateStarPercentage(star);
    return (
        <div className="flex items-center">
            <p className="mr-2 text-base font-semibold">{star} star</p>
            <div className="w-4/5 h-6 bg-gray-200 my-1">
                <div
                    className="h-full  bg-yellow-500"
                    style={{
                        width: `${percentage}%`, // Set the width dynamically based on percentage
                    }}
                ></div>
            </div>
        </div>
    );
};

export default RatingProgressBar;
